import { render, staticRenderFns } from "./SponsorDialog.vue?vue&type=template&id=0d15fedb&scoped=true&"
import script from "./SponsorDialog.vue?vue&type=script&lang=js&"
export * from "./SponsorDialog.vue?vue&type=script&lang=js&"
import style0 from "./SponsorDialog.vue?vue&type=style&index=0&id=0d15fedb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15fedb",
  null
  
)

export default component.exports